/**
 * Utilities for managing visibility of survey items on a page based on defined survey item rules
 */
(function($) {
  $.widget('survey.surveyItemRuleListener', {
    options: {
      pageId:null,
      base_url:null,
      sync:null,
      timeout:null,
      multiselectEnabled:false,
      // these 2 variables if set point to functions that will be called to toggle
      // primary actions pane with back/continue/submit buttons
      enablePrimaryActionPane:null,
      disablePrimaryActionPane:null
    },

    _create: function() {
      // Invoke rule evaluation as soon as an answer field is updated
      if (!$(this.element).hasClass('textQuestion')) {
        this.element.on('change', $.proxy(this.addEvalToQueue, this, null));
      }
      if ($(this.element).hasClass('textQuestion') || $(this.element).hasClass('dateAnswer')) {
        // Date Questions need both the input and change event triggers, so the rules will be evaluated if the user types in the box,
        // or they use the date picker widget
        // We may need to add the event triggers for multiple choice questions once the Other field is working.
        this.addEventTriggersForBrowsers();
      }
      // Check if the jquery-multiselect widget is being used
      if ($.isFunction($.prototype.multiselect)) {
        this.options.multiselectEnabled = true;
      }
    },

    addEventTriggersForBrowsers : function() {
      if ($.browser.msie && parseInt($.browser.version, 10) < 9) {
        //IE 7 and 8 do not support on input. Unlike keyup, propertychange supports paste events with mouse clicks.
        this.element.bind('propertychange', $.proxy(this.addEvalAfterInput, this));
      } else {
        this.element.on('input', $.proxy(this.addEvalAfterInput, this));
      }
    },

    /**
     * Evaluate the necessary rules on page and call show/hide function
     * @param ajaxParams
     */
    addEvalAfterInput : function() {
      if (this.options.timeout !== null) {
        window.clearTimeout(this.options.timeout);
      }
      this.options.timeout = window.setTimeout($.proxy(this.addEvalToQueue, this, null), 500);
    },

    addEvalToQueue : function (ajaxParams) {
      if (this.options.sync === null || this.options.sync.state() === 'resolved') {
        this.options.sync = this.initEvaluateCall(ajaxParams);
      } else {
        this.options.sync.done( $.proxy( function() {
          this.options.sync = this.initEvaluateCall(ajaxParams);
        }, this));
      }
    },

    /**
     * Build the ajax call that will evaluate the survey item rules and toggle visibility on return
     */
    initEvaluateCall : function(ajaxParams) {
      if (ajaxParams === null) {
        var el = jQuery(this.element);
        if ($('#' + el.attr('name') + '\\.dependentItems').val() === 'true') {
          // Filter the form for speed-up purposes
          var formInput = $('#surveyForm').serialize();
          var filteredInput = this.filter(formInput.split('&'));
          var elName = el.attr('name');
          var urlPrefix = '';
          if ($('#anonymous').val() === 'true') {
            urlPrefix = 'anonymous_';
          }
          var requestData = 'pageId=' + this.options.pageId + '&questionChanged=' + this.extractId(elName) + '&' + filteredInput;
          // Show indication that the evaluation is taking place
          $('#surveyLoadingIndicator').show();

          if (typeof this.options.disablePrimaryActionPane !== 'undefined') {
            this.options.disablePrimaryActionPane();
          }

          ajaxParams = {
              url: this.options.base_url + '/ajax/' + urlPrefix + 'evaluate_survey_item_rules.do',
              data: requestData,
              timeout: 8000,
              type: 'POST'
          };
        } else {
          // Do not submit ajax call if it is not a dependent question.
          return null;
        }
      }
      // Once the evaluation action returns, hide the loading message and toggle the visibility of the
      // survey items if the function returns successfully.
      return $.ajax(ajaxParams).done($.proxy(function(msg) {
        this.toggleSurveyItemVisibility( msg.ruleResults, el.attr('name') );
        this.surveyRulesEvalCallback();
      }, this)).fail($.proxy(function() {
        this.addEvalToQueue(ajaxParams);
        this.surveyRulesEvalCallback();
      }, this));
    },

    /**
     * Extract a survey item's id from its name
     * @param name - The string from which to extract the id, assuming it's of the form text_id
     */
    extractId : function(name) {
      var nameAsArray = name.split('_');
      for (var index = 0; index < nameAsArray.length; index++) {
        if (!isNaN(nameAsArray[index])) {
          return nameAsArray[index];
        }
      }
      return name;
    },

    /**
     * Filter the survey form to send only the information needed
     * @param array of string with the request parameters
     * @returns a filtered string that concatenates the necessary parameters
     */
    filter : function(array) {
      var filtered = Array();
      for (var paramIndex = 0; paramIndex < array.length; paramIndex++) {
        var param = array[paramIndex];
        if (param.match('ruleResult=false') === null && param.length !== 0 && param.charAt(param.length - 1) !== '='){
          filtered.push(param);
        }
      }
      return filtered.join('&');
    },

    /**
     * Show/hide survey items on page based on rule evaluation results
     * @param results : The value returned by the ajax call made to evaluate question rules
     */
    toggleSurveyItemVisibility : function(results) {
      for (var itemCode in results) {
        if (results.hasOwnProperty(itemCode)) {
          var el = $('#' + itemCode);
          // If the item should be shown, look for it, show it and update its .ruleResult value to true
          if (results[itemCode]) {
            el.show();
            $('#' + itemCode + '\\.ruleResult').val('true');
            // If the multiselect widget is being used, create a new display for the question if has the multiselect class
            if (this.options.multiselectEnabled) {
              var multiselectElement = $('#' + itemCode).find('.multiselect');
              if (multiselectElement !== null) {
                if (multiselectElement.height() < 100) {
                  multiselectElement.css('height', '200px');
                }
                multiselectElement.multiselect({show:'show'});
              }
            }
          // If the item should not be shown, hide it and update its .ruleResult value to false
          } else {
            el.hide();
            $('#' + itemCode + '\\.ruleResult').val('false');
            // If the multiselect widget is being used, destroy the display that was showing the question if applicable
            if (this.options.multiselectEnabled) {
              $('#' + itemCode).find('.multiselect').multiselect('destroy');
            }
          }
        }
      }
    },

    /**
     * Process survey rule evaluation callback. Remove loading indicator, enable primary action pane (back and continue buttons).
     */
    surveyRulesEvalCallback : function() {
      $('#surveyLoadingIndicator').hide();
      if (typeof this.options.enablePrimaryActionPane !== 'undefined') {
        this.options.enablePrimaryActionPane();
      }
    }
  });
}) (jQuery);
